export var BlockType;
(function (BlockType) {
    BlockType["Block"] = "BLOCK";
    BlockType["BuildingBlock"] = "BUILDING_BLOCK";
    BlockType["Layout"] = "LAYOUT";
})(BlockType || (BlockType = {}));
//# sourceMappingURL=block.types.js.map